import apolloColours from './apolloColours';

// All the theme overrides for date picker.
const datePickerThemeOverrides = {
  MuiPickersBasePicker: {
    container: {
      background: `linear-gradient(0deg, ${apolloColours.foreground}, ${apolloColours.foreground})`,
      boxShadow: '0px 2px 4px rgba(0, 0, 0, 0.08)',
      borderRadius: '6px',
      boxSizing: 'border-box',
    },
    pickerView: {
      padding: '12px 16px',
      minHeight: '260px',
      minWidth: '242px',
    },
  },
  MuiPickersCalendar: {
    transitionContainer: {
      minHeight: '178px',
      maxHeight: '100%',
      marginTop: '5px',
    },
  },
  MuiPickersToolbar: {
    toolbar: {
      backgroundColor: apolloColours.foreground,
      padding: '12px 18px',
      borderBottom: `1px solid ${apolloColours.stoke}`,
      height: 'fit-content',
      '&>:not(:last-child)': {
        marginBottom: '8px',
      },
    },
  },
  MuiPickersToolbarText: {
    toolbarTxt: {
      fontStyle: 'normal',
      fontSize: '16px',
      fontWeight: '400',
      lineHeight: '17px',
      color: apolloColours.secondary.default,
    },
    toolbarBtnSelected: {
      fontStyle: 'normal',
      fontSize: '16px',
      fontWeight: '400',
      lineHeight: '17px',
      color: apolloColours.text.primary,
    },
  },

  MuiPickersCalendarHeader: {
    transitionContainer: {
      '& p': {
        fontSize: '16px',
        lineHeight: '20px',
        color: apolloColours.text.primary,
      },
    },
    iconButton: {
      padding: 0,
    },
    dayLabel: {
      color: apolloColours.text.secondary,
    },
  },
  MuiPickersDay: {
    day: {
      color: apolloColours.text.primary,
      lineHeight: '12px',
      '&:active': {
        color: apolloColours.secondary.default,
      },
      '&:hover': {
        color: apolloColours.foreground,
        backgroundColor: apolloColours.secondary.hover,
      },
    },
    daySelected: {
      backgroundColor: apolloColours.secondary.default,
      color: apolloColours.foreground,
      '&:hover': {
        backgroundColor: apolloColours.secondary.default,
      },
    },
    dayDisabled: {
      color: apolloColours.action.disabled,
    },
    current: {
      color: apolloColours.secondary.default,
    },
  },

  MuiPickersYear: {
    root: {
      color: apolloColours.text.primary,
      '&:active': {
        color: apolloColours.secondary.default,
      },
    },
    yearSelected: {
      fontSize: '20px',
      color: apolloColours.secondary.default,
      '&:hover': {
        color: apolloColours.secondary.default,
      },
    },
  },
};

export default datePickerThemeOverrides;
